import { NewUserScreen } from "@/features/auth/screens/NewUserScreen";
import { newUserIndexRouteSearchSchema } from "@/features/auth/search/authRouteSearch";
import type { QuickstartT, RoleT } from "@patient-watch/types";
import { createFileRoute } from "@tanstack/react-router";

const NewUser = () => {
    const { email, phone, invited_by_name, method, contactMethod } = Route.useSearch();
    return (
        <NewUserScreen
            email={email}
            phone={phone}
            invitedByName={invited_by_name}
            method={method}
            contactMethod={contactMethod}
        />
    );
};

export type OrganisationSummary = {
    organisation_id: string;
    organisation_name: string;
};

export type SignupSearch = {
    role?: RoleT;
    email?: string;
    phone?: string;
    organisation?: OrganisationSummary;
    quickstart?: QuickstartT;
};

export const Route = createFileRoute("/_auth/new-user/")({
    component: NewUser,
    validateSearch: (search) => newUserIndexRouteSearchSchema.parse(search ?? {}),
});
